import { Users } from "lucide-react";
import React from "react";
import HexagonBadge from "utils/HexagonBadge";

const RoleDetailsModal = ({ item }) => {
 
  return (
    <div className="flex flex-col justify-between gap-5">
      <div className="flex flex-col items-start flex-wrap justify-between gap-1">
        <div className="flex items-center flex-col gap-1 w-full ">
          <div className="flex items-center flex-col gap-2.5 ">
            <HexagonBadge
              size={"size-[60px]"}
              badge={<Users className={`text-3xl text-blue-400`} />}
              stroke="stroke-blue-200"
              fill="fill-blue-50 "
            />
            <div className="flex flex-col">
              <div className="text-base font-medium text-xl hover:text-primary-active mb-px">
                {item?.name}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5 font-medium">
          <span>Role Permissions :</span>
        </div>
        <div className="flex flex-wrap gap-2.5 mt-2">
          {item?.access?.map((item, index) => {
            return (
              <span
                key={index}
                className="inline-flex items-center justify-center border bg-secondary border-transparent rounded-md p-2 h-6 min-w-6 gap-1.5 text-xs"
              >
                {/* <Tag color={item.color_code} size={16} strokeWidth={1.5} /> */}
                <span className="text-mono text-[12px] font-medium">
                  {item.name}
                </span>
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RoleDetailsModal;
